var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignElement3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10169",
    "data-name": "Group 10169",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5651",
    "data-name": "Rectangle 5651",
    width: 492,
    height: 469.292,
    fill: "#31e5e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10166",
    "data-name": "Group 10166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10164",
    "data-name": "Group 10164",
    transform: "translate(21 502) rotate(-90)",
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10065",
    "data-name": "Group 10065",
    transform: "translate(0 0)",
    opacity: 0.26,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6947",
    "data-name": "Path 6947",
    d: "M55.671,28.241A28.037,28.037,0,0,1,27.836,56.481,28.037,28.037,0,0,1,0,28.241,28.037,28.037,0,0,1,27.836,0,28.037,28.037,0,0,1,55.671,28.241",
    transform: "translate(0 0.003)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6948",
    "data-name": "Path 6948",
    d: "M73.625,28.241a27.839,27.839,0,1,1-55.671,0,27.839,27.839,0,1,1,55.671,0",
    transform: "translate(127.494 0.003)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6949",
    "data-name": "Path 6949",
    d: "M91.578,28.241a27.839,27.839,0,1,1-55.671,0,27.839,27.839,0,1,1,55.671,0",
    transform: "translate(254.982 0.003)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6950",
    "data-name": "Path 6950",
    d: "M109.531,28.241a27.839,27.839,0,1,1-55.671,0,27.839,27.839,0,1,1,55.671,0",
    transform: "translate(382.469 0.003)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6951",
    "data-name": "Path 6951",
    d: "M55.671,44.983A28.037,28.037,0,0,1,27.836,73.223a28.244,28.244,0,0,1,0-56.481A28.037,28.037,0,0,1,55.671,44.983",
    transform: "translate(0 120.865)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6952",
    "data-name": "Path 6952",
    d: "M73.625,44.983A27.839,27.839,0,1,1,45.79,16.742,28.037,28.037,0,0,1,73.625,44.983",
    transform: "translate(127.494 120.865)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6953",
    "data-name": "Path 6953",
    d: "M91.578,44.983A27.839,27.839,0,1,1,63.743,16.742,28.037,28.037,0,0,1,91.578,44.983",
    transform: "translate(254.982 120.865)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6954",
    "data-name": "Path 6954",
    d: "M109.531,44.983A27.839,27.839,0,1,1,81.7,16.742a28.037,28.037,0,0,1,27.836,28.241",
    transform: "translate(382.469 120.865)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6955",
    "data-name": "Path 6955",
    d: "M55.671,61.725A28.037,28.037,0,0,1,27.836,89.965a28.244,28.244,0,0,1,0-56.481A28.037,28.037,0,0,1,55.671,61.725",
    transform: "translate(0 241.727)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    d: "M73.625,61.725A27.839,27.839,0,1,1,45.79,33.484,28.037,28.037,0,0,1,73.625,61.725",
    transform: "translate(127.494 241.727)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6957",
    "data-name": "Path 6957",
    d: "M91.578,61.725A27.839,27.839,0,1,1,63.743,33.484,28.037,28.037,0,0,1,91.578,61.725",
    transform: "translate(254.982 241.727)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6958",
    "data-name": "Path 6958",
    d: "M109.531,61.725A27.839,27.839,0,1,1,81.7,33.484a28.037,28.037,0,0,1,27.836,28.241",
    transform: "translate(382.469 241.727)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6959",
    "data-name": "Path 6959",
    d: "M55.671,78.466a28.037,28.037,0,0,1-27.836,28.241,28.244,28.244,0,0,1,0-56.481A28.037,28.037,0,0,1,55.671,78.466",
    transform: "translate(0 362.581)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6960",
    "data-name": "Path 6960",
    d: "M73.625,78.466A27.839,27.839,0,1,1,45.79,50.225,28.037,28.037,0,0,1,73.625,78.466",
    transform: "translate(127.494 362.581)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6961",
    "data-name": "Path 6961",
    d: "M91.578,78.466A27.839,27.839,0,1,1,63.743,50.225,28.037,28.037,0,0,1,91.578,78.466",
    transform: "translate(254.982 362.581)",
    fill: "#31e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6962",
    "data-name": "Path 6962",
    d: "M109.531,78.466A27.839,27.839,0,1,1,81.7,50.225a28.037,28.037,0,0,1,27.836,28.241",
    transform: "translate(382.469 362.581)",
    fill: "#31e5e5"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5681",
    "data-name": "Rectangle 5681",
    width: 512,
    height: 512,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignElement3);
export default __webpack_public_path__ + "static/media/designElement3.f0984728b2be7244aae6c75dbb258cf2.svg";
export { ForwardRef as ReactComponent };